import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 4C8.24 4 8.47 4.08 8.66 4.25L16.66 11.25C16.88 11.44 17 11.71 17 12C17 12.29 16.88 12.56 16.66 12.75L8.66 19.75C8.37 20.01 7.95 20.07 7.59 19.91C7.23 19.75 7 19.39 7 19V5C7 4.61 7.23 4.25 7.59 4.09C7.72 4.03 7.86 4 8 4Z" fill={ fill || 'currentColor' }/>
    </svg>
);
